import NavbarSection from "@/components/LandingPage/Navbar/NavbarSection.vue";
import HeroSection from "@/components/LandingPage/Hero/HeroSection.vue";
import PlatformFeatures from "@/components/LandingPage/PlatformFeatures/PlatformFeatures.vue";
import ScoreCardElements from "@/components/LandingPage/ScoreCardElements/ScoreCardElements.vue";
import FooterSection from "@/components/LandingPage/Footer/FooterSection.vue";

export default {
  name: "LandingPage",
  components: {
    NavbarSection,
    HeroSection,
    PlatformFeatures,
    ScoreCardElements,
    FooterSection,
  },
};
